/**
 * Alshallal Pastry Company HR System - AI Floating Chat Button
 * Phase 23: In-App AI Copilot
 * 
 * A floating action button that opens the AI chat panel
 */
import React, { useState } from 'react';
import { Bot, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AIChatPanel from './AIChatPanel';
import { cn } from '@/lib/utils';

const AIFloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <>
      {/* Floating Chat Panel */}
      {isOpen && (
        <AIChatPanel
          isFloating={true}
          isOpen={isOpen}
          onToggle={() => setIsOpen(false)}
        />
      )}
      
      {/* AI Floating Button */}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "fixed bottom-20 right-4 z-40 h-14 w-14 rounded-full shadow-brand-orange transition-all hover:scale-110 hover:rotate-3",
          "bg-brand-orange hover:bg-brand-orange/90 text-white animate-pulse-glow",
          isOpen && "hidden"
        )}
        size="icon"
        aria-label="Open AI Assistant"
      >
        <Bot className="h-6 w-6" />
      </Button>
    </>
  );
};

export default AIFloatingButton;
